import { connectRouter, routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import { persistReducer, persistStore } from "redux-persist";
import createWebStorage from "redux-persist/lib/storage/createWebStorage";
import createSagaMiddleware from "redux-saga";
import {
    createStateSyncMiddleware, initMessageListener, withReduxStateSync
} from "redux-state-sync";

import { combineReducers, configureStore } from "@reduxjs/toolkit";

import adminSlice from "./admin/adminSlice";
import adminDashboardReducer from "./adminDashboard/adminDashboardSlice";
import caseReducer from "./cases/casesSlice";
import { crossTabBlacklist } from "./crossTabBlacklist";
import messagesReducer from "./messages/messagesSlice";
import paymentMethodFormReducer from "./paymentMethodForm/paymentMethodFormSlice";
import priceReducer from "./prices/pricesSlice";
import questionnaireReducer from "./questionnaire/questionnaireSlice";
import removedMedicationsReducer from "./removedMedications/removedMedicationsSlice";
import saga from "./saga";
import uSlice from "./ui/uiSlice";
import userReducer from "./user/userSlice";

export const history = createBrowserHistory();

const userPersistConfig = {
  key: "user",
  storage: createWebStorage("local"),
};

const persistConfig = {
  key: "root",
  storage: createWebStorage("session"),
  blacklist: crossTabBlacklist,
};

const reactRouterMiddleware = routerMiddleware(history);

const rootReducer = () =>
  combineReducers({
    router: connectRouter(history),
    user: persistReducer(userPersistConfig, userReducer),
    questions: questionnaireReducer,
    case: caseReducer,
    removedMedications: removedMedicationsReducer,
    price: priceReducer,
    messages: messagesReducer,
    ui: uSlice,
    admin: adminSlice,
    adminDashboard: adminDashboardReducer,
    paymentMethodForm: paymentMethodFormReducer,
  });

const persistedReducer = persistReducer(persistConfig, withReduxStateSync(rootReducer()));
const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [reactRouterMiddleware, sagaMiddleware, createStateSyncMiddleware(persistConfig)],
  devTools: true,
});
export const persistor = persistStore(store);

sagaMiddleware.run(saga);

initMessageListener(store);
